<template>
  <form @submit="submitForm">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-center" style="padding: 27px;background-color: #f2f4f5;">
          <company-card :company="company" :remoteMeasures="remoteMeasures"></company-card>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 my-5">
        <preview-company-summary :company="company" :remoteMeasures="remoteMeasures"></preview-company-summary>
      </div>
    </div>

    <div class="form-group my-4 d-flex justify-content-end">
      <button type="submit" class="btn wfh-btn-primary">
        Finish & Go To Dashboard
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    oldData: {
      required: false,
    },
  },

  data () {
    return {
      oldDataParsed: {},
      company: {},
      remoteMeasures: {},
      formData: {
        company_id: null,
      },
    };
  },

  methods: {
    async submitForm (e) {
      e.preventDefault();

      await axios.post(window.location.pathname, this.formData);

      window.location = '/dashboard';
    },
  },

  mounted () {
    this.oldDataParsed = JSON.parse(this.oldData);
    this.company = this.oldDataParsed.companies[0];
    this.formData.company_id = this.company.id;
    this.remoteMeasures = this.company.remote_measures;
  },
};
</script>

<style scoped lang="scss">
</style>
